import { Navigate, useLocation } from "react-router-dom";

export default function PersonBillingPage() {
  const location = useLocation();
  return <Navigate to={`${location.pathname}/orders`} replace />;
}
